import { useEnrollmentContext } from "@/state";

import { createSearchParams, useNavigate } from "react-router";


export const useNavigateSearch = (preserveClient = true) => {
  const navigate = useNavigate();
  const experienceData = useEnrollmentContext();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (pathname: string, params?: { [key: string]: any }) => {
    let paramsToSend = { ...(params || {}) };

    if (preserveClient && !Object.keys(paramsToSend).includes("client")) {
      paramsToSend = { ...paramsToSend, "client": experienceData.experience.identifier };
    }

    navigate({
      pathname: pathname,
      search: `?${createSearchParams(paramsToSend)}`,
    });
  };
};
